
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autopfand-formular/kontaktdaten",
      function () {
        return require("private-next-pages/autopfand-formular/kontaktdaten.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autopfand-formular/kontaktdaten"])
      });
    }
  